import GameStateControl from "../../GameStateControl.js";
import Totals from "../../model/crew/Totals";
import GameOptions from "../../model/options/GameOptions.js";
import Statistics from "../../model/statistics/Statistics";
import Page from "../framework/Page";
import ParentView from "../framework/ParentView";
import PopupViewController from "../menu/PopupViewController";
import { PageIds } from "../PageIds.js";
import CloseSkillTreePopupView from "./CloseSkillTreePopupView.js";
import GameOptionsPopupView from "./options/GameOptionsPopupView.js";
import OfflinePopupView from "./OfflinePopupView.js";
import PerformanceMetricsPopupView from "./PerformanceMetricsPopupView.js";
import PrestigePopupView from "./PrestigePopupView";
import SavePopupView from "./SavePopupView";
import StatisticsPopupView from "./stats/StatisticsPopupView.js";
import OfflineLogic from "../../logic/OfflineLogic.js";
import VersionPopupView from "./VersionPopupView.js";

export default class PopupContainer extends ParentView {

    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {Statistics} runStatistics
     * @param {Statistics} globalStatistics
     * @param {Totals} totals
     * @param {GameOptions} gameOptions
     * @param {GameStateControl} gameStateControl
     * @param {OfflineLogic} offlineLogic
     * @param {PopupViewController} popupViewController
     */
    constructor(parentId, elementId, runStatistics, globalStatistics, totals, gameOptions, gameStateControl, offlineLogic, popupViewController) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {Totals}
         */
        this.totals = totals;
        /**
         * @constant
         * @type {PopupViewController}
         */
        this.popupViewController = popupViewController;

        const statisticsPopupView = new StatisticsPopupView(elementId, runStatistics, globalStatistics);
        const savePopupView = new SavePopupView(elementId, gameStateControl);
        const prestigePopupView = new PrestigePopupView(elementId, totals, gameStateControl);
        const closeSkillTreeView = new CloseSkillTreePopupView(elementId, popupViewController);
        const offlinePopupView = new OfflinePopupView(elementId, totals, offlineLogic);
        const versionPopupView = new VersionPopupView(elementId);
        const gameOptionsView = new GameOptionsPopupView(elementId, gameOptions)
        const performanceView = new PerformanceMetricsPopupView(elementId);

        popupViewController.addPopupView(statisticsPopupView);
        popupViewController.addPopupView(savePopupView);
        popupViewController.addPopupView(prestigePopupView);
        popupViewController.addPopupView(closeSkillTreeView);
        popupViewController.addPopupView(offlinePopupView);
        popupViewController.addPopupView(versionPopupView);
        popupViewController.addPopupView(gameOptionsView);
        popupViewController.addPopupView(performanceView);

        this.addView(statisticsPopupView);
        this.addView(savePopupView);
        this.addView(prestigePopupView);
        this.addView(closeSkillTreeView);
        this.addView(offlinePopupView);
        this.addView(versionPopupView);
        this.addView(gameOptionsView);
        this.addView(performanceView);
    }

    /**
     * @override
     */
    initializeView() {

        // <div id="popupContainer" class="popup-container">

        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'popup-container');

        super.initializeView();
    }

    /**
     * @override
     */
    updateView() {
        if (this.totals.countedOfflineSeconds > 0 && !this.popupViewController.isPopupVisible(PageIds.OFFLINE_POPUP)) {
            this.popupViewController.setPopupVisible(PageIds.OFFLINE_POPUP);
        }

        super.updateView();
    }
}